import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { FaTimes } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const GallerySlider = () => {
    const [images, setImages] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);

    // cPanel Live Domain aur Localhost dono ke liye automatic URL configuration
    const baseUrl = window.location.hostname === "localhost"
        ? 'http://66.116.250.115:9000'
        : "https://rajkurumaenterprises.com";

    useEffect(() => {
        fetch(`${baseUrl}/api/gallery/`)
            .then(res => res.json())
            .then(data => setImages(data))
            .catch(err => console.error("Error fetching gallery:", err));
    }, [baseUrl]);

    if (images.length === 0) return null;

    return (
        <section className="py-12 md:py-16 bg-white overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
                <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-gray-900 text-center mb-8 md:mb-10 tracking-tight">
                    Our Gallery
                </h2>

                <Swiper
                    modules={[Autoplay, Navigation, Pagination]}
                    spaceBetween={15}
                    slidesPerView={1}
                    breakpoints={{
                        640: { slidesPerView: 2, spaceBetween: 20 },
                        1024: { slidesPerView: 3, spaceBetween: 25 },
                    }}
                    loop={true}
                    navigation={true}
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 3500, disableOnInteraction: false }}
                    className="pb-12 px-2"
                >
                    {images.map((item, index) => {
                        const imageUrl = item.image.startsWith('http')
                            ? item.image
                            : `${baseUrl}${item.image}`;

                        return (
                            <SwiperSlide key={index}>
                                <div
                                    onClick={() => setSelectedImage(imageUrl)}
                                    className="bg-gray-100 rounded-2xl overflow-hidden shadow-lg h-64 sm:h-72 border border-gray-200 cursor-pointer group relative"
                                >
                                    <img
                                        src={imageUrl}
                                        alt={item.title || "Gallery Image"}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                    />
                                    {/* Hover overlay hint */}
                                    <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                        <span className="bg-white/80 text-gray-900 text-xs font-bold px-3 py-1.5 rounded-full shadow-md">
                                            Click to View
                                        </span>
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>

            {/* --- LIGHTBOX MODAL --- */}
            {selectedImage && (
                <div
                    className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 backdrop-blur-sm"
                    onClick={() => setSelectedImage(null)}
                >
                    <div className="relative max-w-4xl w-full max-h-[90vh] flex items-center justify-center">
                        {/* Close Button */}
                        <button
                            onClick={() => setSelectedImage(null)}
                            className="absolute -top-12 right-0 sm:right-4 text-white bg-white/20 hover:bg-white/40 p-2 rounded-full text-xl transition z-50 focus:outline-none"
                            title="Close"
                        >
                            <FaTimes />
                        </button>

                        {/* Badi Image */}
                        <img
                            src={selectedImage}
                            alt="Zoomed Gallery"
                            className="max-w-full max-h-[85vh] object-contain rounded-xl shadow-2xl border-2 border-white/20"
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>
                </div>
            )}
        </section>
    );
};

export default GallerySlider;